// import React, { useState } from 'react'
// import './App.css'
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import { useEffect } from 'react'
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min'
// import Navigation from './component/adminDashboard/Navbar'
// import AdminLogin from './component/AdminLogin/AdminLogin'
// import BookingForm from './component/BookingForm/BookingForm'

// const App = () => {

//  const [condition,setCondition]=useState(null)
//  const getSession = sessionStorage.getItem('email')

//  useEffect(()=>{
//    setCondition(getSession)
//  })

//  return (
//     <div>
//      <BrowserRouter>
//               {
//                condition===null? <AdminLogin condition={setCondition}></AdminLogin>:<Navigation condition={setCondition}></Navigation>
//               }
//                      <Routes>
//                      <Route path='/form' element={<BookingForm></BookingForm>} />
//                      </Routes>
//      </BrowserRouter>
//     </div>
//   )
// }

// export default App

// import React, { useState, useEffect } from 'react';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
// import './App.css';

// import Navigation from './component/adminDashboard/Navbar';
// import AdminLogin from './component/AdminLogin/AdminLogin';

// import UserDelete from './component/UserDelete/UserDelete';
// import ChildSafety from './component/ChildSafety/ChildSafety';
// import AdminSignup from './component/AdminLogin/AdminSignup';
// import OtpVerification from './component/AdminDataBaseSystem/OtpVerification';
// import ClubLogin from './component/ClubLogin/ClubLogin';

// const App = () => {
//   const [condition, setCondition] = useState(null);

//   useEffect(() => {
//     const getSession = sessionStorage.getItem('email');
//     setCondition(getSession);
//   }, []);

//   return (
//     <BrowserRouter>
//       <Routes>

//         <Route path='/delete' element={<UserDelete/>}/>
//         <Route path='/child-safety-policy' element={<ChildSafety/>}/>
//    <Route path='/admin-signup' element={<AdminSignup />} />
//     <Route path='/club-login' element={<ClubLogin />} />
//              <Route path="/verify-otp" element={<OtpVerification />} />
//         {/* If not logged in, show login */}
//         <Route
//           path="/*"
//           element={
//             condition === null ? (
//               <AdminLogin condition={setCondition} />
//             ) : (
//               <Navigation condition={setCondition} />
//             )
//           }
//         />
//       </Routes>
//     </BrowserRouter>
//   );
// };

// export default App;


//12-06-2026


import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';

import Navigation from './component/adminDashboard/Navbar';
import AdminLogin from './component/AdminLogin/AdminLogin';
import ClubLogin from './component/ClubLogin/ClubLogin';
import UserDelete from './component/UserDelete/UserDelete';
import ChildSafety from './component/ChildSafety/ChildSafety';
import AdminSignup from './component/AdminLogin/AdminSignup';
import OtpVerification from './component/AdminDataBaseSystem/OtpVerification';

const App = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  // Synchronize session on component mount
  useEffect(() => {
    updateSessionContext();
  }, []);

  const updateSessionContext = () => {
    const role = sessionStorage.getItem('role');
    const id = sessionStorage.getItem('id');
    
    if (role && id) {
      setSession({ role, id });
    } else {
      setSession(null);
    }
    setLoading(false);
  };

  if (loading) return null; // Avoid premature redirect blinks while reading storage

  return (
    <BrowserRouter>
      <Routes>
        {/* 1. Public Utility Routes */}
        <Route path='/delete' element={<UserDelete />} />
        <Route path='/child-safety-policy' element={<ChildSafety />} />
        <Route path='/admin-signup' element={<AdminSignup />} />
        <Route path="/verify-otp" element={<OtpVerification />} />

        {/* 2. Isolated Club Login Route */}
        <Route 
          path='/club-login' 
          element={session ? <Navigate to="/" replace /> : <ClubLogin condition={updateSessionContext} />} 
        />

        {/* 3. Core Structural Security Routing Handler */}
        <Route
          path="/*"
          element={
            session === null ? (
              // If logged out, render the default Admin Login directly on the current path
              <AdminLogin condition={updateSessionContext} />
            ) : (
              // If logged in, pass control down to Navigation to render your original navbar & child sub-routes
              <Navigation condition={updateSessionContext} />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;